import { createFileRoute, redirect } from '@tanstack/react-router';

import { medplum } from '@/config/medplum';
import { APP_PERMISSIONS, getUserPermissions, hasPermission } from '@/lib/auth/permissions';

export const Route = createFileRoute('/')({
	beforeLoad: async () => {
		const activeLogin = medplum.getActiveLogin();

		if (activeLogin) {
			const { permissions } = await getUserPermissions();
			if (hasPermission(permissions, APP_PERMISSIONS.PATIENT_CARE)) {
				throw redirect({ to: '/patients', replace: true });
			}
			throw redirect({ to: '/dashboard', replace: true });
		}
	},
});
